<template>
  <div class="exchange">
    <div class="header"></div>
    <div class="input-wrapper">
      <input
        v-model="serialNumber"
        type="text"
        class="input-serial"
        :placeholder="placeholder"
        maxlength="20"
        @focus="placeholder = ''"
        @blur="handleBlur"
      />
    </div>
    <div v-if="tips" class="tips-wrapper">
      <p class="red-tip">{{ tips }}</p>
      <div
        v-if="
          data.status === 'no-exist' ||
          data.status === 'actived' ||
          data.status === 'expired'
        "
        class="feedback"
        @click="feedback"
      >
        <img src="../assets/feedback.svg" />
        反馈
      </div>
    </div>
    <div
      class="btn-exchange"
      :class="{ disabled: !serialNumber }"
      @click="exchange"
    >
      兑换
    </div>
    <BasicModelExchange
      v-if="open"
      :data="subjectData"
      @close="close"
      @confirm="confirm"
    ></BasicModelExchange>
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';
import BasicModelExchange from '../components/basic-model-exchange.vue';
import toast from '@/basic/components/Toast';

const NO_ANTH = 401;
const FORBIDDEN = 403;

@Component({
  components: {
    BasicModelExchange,
  },
})
export default class Exchange extends Vue {
  open = false;
  serialNumber = '';
  lockStatus = false; // 兑换按钮加锁
  lockConfirm = false; // 确认兑换加速
  tips = '';
  data: object = {};
  subjectData: object = {};
  placeholder = '请输入序列号';
  toastData = {
    type: 'error_network',
    value: '网络失败',
  };

  exchange() {
    if (this.serialNumber && !this.lockStatus) {
      this.lockStatus = true;
      window.apis
        .exchangeSerialNumber({ code: this.serialNumber, force: false })
        .then((res: any) => {
          if (res && !res.errcode) {
            this.previousNumber = this.serialNumber;
            this.data = res.data;
            this.handleStatus(res.data.status, res.data);
            this.lockStatus = false;
          }
          if (res.errcode === FORBIDDEN) {
            this.tips = res.errmsg;
            this.lockStatus = false;
            this.data = {};
          }
        })
        .catch((error: any) => {
          // 调用网络错误弹窗
          if (error.status !== NO_ANTH) {
            this.lockStatus = false;
            toast(this.toastData);
          }
        });
    }
  }
  close(event: boolean) {
    this.open = event;
  }
  feedback() {
    window.location.href =
      'https://www.pypypy.cn/fos/feedback-mobile/#/feedback';
  }
  confirm() {
    if (this.serialNumber && !this.lockConfirm) {
      this.lockConfirm = true;
      window.apis
        .exchangeSerialNumber({ code: this.serialNumber, force: true })
        .then((res: any) => {
          if (res && !res.errcode) {
            this.open = false;
            this.data = res.data;
            this.handleStatus(res.data.status, res.data);
            this.lockConfirm = false; // 解锁
          }
        })
        .catch((error: any) => {
          this.lockConfirm = false; // 解锁
          toast(this.toastData);
        });
    }
  }
  handleStatus(status: string, data: any) {
    let content = '您已获得';

    switch (status) {
      case 'success':
        // 兑换成功
        for (let i = 0; i < data.app_name.length; i++) {
          content = content + `【${data.app_name[i]}】`;
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          if (i < data.app_name.length - 1) {
            content += '+';
          } else {
            content += '学习资格';
          }
        }
        this.subjectData = {
          type: 'success',
          title: '兑换成功',
          content: content,
        };
        this.open = true;
        break;

      case 'user-cover':
      case 'staff-cover':
        // 已经有部分课程
        this.tips = '';
        this.subjectData = {
          type: 'confirm',
          title: '是否要使用该序列号',
          content:
            '你已获得该组合课学习卡中包含课程的学习资格，是否还要兑换该序列号，兑换后该序列号将失效。',
        };
        this.open = true;
        break;
      default:
        // 序列号不存在 或 序列号已使用 或 序列号已过期 或 已经有对应的全部课程 或者 no-match 不在可以兑换序列号的人群范围内
        this.tips = data.title;
    }
  }
  handleBlur() {
    const top_pos = 0;
    this.placeholder = '请输入序列号';
    window.scrollTo(top_pos, top_pos); // 处理ios下唤醒输入法弹窗收起后留白问题
  }
}
</script>

<style lang="scss" scoped>
.exchange {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow-y: hidden;
  font-family: 'PingFang SC';
  background: #ffffff;
  .header {
    width: 100%;
    height: 420px;
    background: url('../assets/exchange-header.png');
    background-size: 100% 100%;
    border: 0;
  }
  .input-wrapper {
    display: flex;
    justify-content: center;
    margin-top: -60px;
    .input-serial {
      width: 574px;
      height: 120px;
      padding: 32px 150px;
      color: #31285d;
      font-weight: bold;
      font-size: 40px;
      text-align: center;
      text-overflow: ellipsis;
      background: #ffffff;
      border: 0;
      border-radius: 60.5px;
      box-shadow: 0 6px 38px 0 rgba(100, 89, 188, 0.29);
      &::placeholder {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 32px auto;
        color: #31285d;
        font-weight: normal;
        font-size: 40px;
        opacity: 0.4;
      }
    }
  }
  .tips-wrapper {
    position: absolute;
    top: 513px;
    display: flex;
    justify-content: center;
    width: 100%;
    color: #fe6492;
    font-size: 28px;
    font-family: 'PingFang SC';

    .feedback {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 40px;
      color: #6741ef;
      img {
        width: 26px;
        height: 26px;
        margin-right: 8px;
      }
    }
  }
  .btn-exchange {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 374px;
    height: 86px;
    margin: 145px auto;
    color: #ffffff;
    font-weight: bold;
    font-size: 36px;
    font-family: 'PingFang SC';
    background: #6741ef;
    border-radius: 43px;
    user-select: none;
    &:active {
      background: #805ff5;
    }
  }
  .disabled {
    opacity: 0.3;
  }
}
</style>
